import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../Support/with_presenter';
import {WorkoutIndexPresenter} from './WorkoutIndexPresenter';
import {Loader} from '../Components/Utils/Loader';
import {WorkoutsTable} from './Components/WorkoutsTable';
import {NetworkRequestStatusView} from '../Components/Utils/NetworkRequestStatusView';
import {useSearchParams} from 'react-router-dom';
import {fromSearchParams} from '../../Support/query';
import {ErrorPlaceholder} from '../Components/Utils/ErrorPlaceholder';
import {deserialise} from './Components/WorkoutsTableFilter';

interface OwnProps {}

const WorkoutIndexComponent: FunctionComponent<OwnProps & PresenterProps<WorkoutIndexPresenter>> = observer(
    ({presenter}) => {
        const [searchParams] = useSearchParams();
        return (
            <NetworkRequestStatusView
                result={presenter.result}
                loader={() => (
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1>My workouts</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Loader className="mt-5" />
                            </div>
                        </div>
                    </div>
                )}
                error={() => (
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1>My workouts</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ErrorPlaceholder large className="mt-5" />
                            </div>
                        </div>
                    </div>
                )}
                component={(data) => (
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1>My workouts</h1>
                            </div>
                        </div>

                        <WorkoutsTable
                            initialPartialFilter={deserialise(fromSearchParams(searchParams))}
                            partialWorkouts={data}
                        />
                    </div>
                )}
            />
        );
    },
);

export const WorkoutIndex = withPresenter<WorkoutIndexPresenter, OwnProps>(
    (props, component) => new WorkoutIndexPresenter(component.network.workouts),
    WorkoutIndexComponent,
);
